/**
 * High-conflict detection thresholds for the HITL workflow.
 */
export const HighConflict = {
	/** Segment-count threshold above which a page is flagged as high-conflict. */
	segmentThreshold: 50,
} as const;
